import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import SubscriptionCancellation from './SubscriptionCancellation';
import { parseBoolean } from '../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-subscription-cancellation',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const subscriptionId = container.getAttribute('subscriptionId');
		const isManageable = parseBoolean(container.getAttribute('isManageable'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<SubscriptionCancellation
						subscriptionId={subscriptionId}
						isManageable={isManageable}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
